<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="图片">
      <div @click="showGallery(1)" style="width: 168px; height: 160px">
        <t-image style="width: 100%;height: 100%;background: none"
            :src="attribute.img ? fileUrl + attribute.img : require('@/assets/custom/imgQuota/quota.svg')" fit="fill"/>
      </div>
    </t-form-item>
    <t-form-item label="聚焦图片">
      <div @click="showGallery(2)" style="width: 168px; height: 160px">
        <t-image style="width: 100%; height: 100%;background: none"
                  :src="attribute.activeImg ? fileUrl + attribute.activeImg : require('@/assets/custom/imgQuota/quota_active.svg')" fit="fill"/>
      </div>
    </t-form-item>
    <div style="width: 100%;text-align: center;"><!--告警配置、环形图/进度图-->
      <div style="text-align: center;margin-bottom: 10px;color: inherit;width: 100px;">告警触发:</div>
      <t-row>
        <t-col :span="2"></t-col>
        <t-col :span="5">条件</t-col>
        <t-col :span="5">目标值</t-col>
      </t-row>
      <t-row style="margin-top: 14px;">
        <t-col :span="2">数值</t-col>
        <t-col :span="5">
          <t-select v-model="attribute.alarmConfig.operator" size="small" style="width: 90px;">
            <t-option value=">" label=">"/>
            <t-option value="<" label="<"/>
            <t-option value="=" label="="/>
            <t-option value=">=" label=">="/>
            <t-option value="<=" label="<="/>
          </t-select>
        </t-col>
        <t-col :span="5">
          <t-input-number v-model="attribute.alarmConfig.threshold" theme="normal" size="small" style="margin-left: -15px;width: 90px;"/>
        </t-col>
      </t-row>
    </div>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
  </t-form>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import {fileUrl} from "/env";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-img-quota-option",
  components: {Gallery,CptData},
  props: {
     attribute: Object,
     cptDataForm:Object, 
    },
  data(){
    return {
      imgType:1,
      fileUrl
    }
  },
  methods:{
    showGallery(type){
      this.imgType = type;
      this.$refs.gallery.opened();
    },
    confirmCheck(path){
      if(this.imgType === 1){
        this.attribute.img = path
      }else{
        this.attribute.activeImg = path
      }
    }
  }
}
</script>

<style scoped>
</style>
